module.exports = __webpack_public_path__ + "img/index_01.25095cf6.png";